// Pure translation helpers, kept apart from the React provider so tests run without a browser.
import { catalogue, type Lang, type MessageKey, type Text } from './catalogue'

export const isLang = (v: unknown): v is Lang => v === 'en' || v === 'fil'

/** The browser's preference: Filipino for `fil*` or `tl*`, else English. */
export function browserLang(languages: readonly string[] = typeof navigator === 'undefined' ? [] : navigator.languages ?? []): Lang {
  return languages.some((l) => /^(fil|tl)\b/i.test(l)) ? 'fil' : 'en'
}

const plurals: Record<Lang, Intl.PluralRules> = {
  en: new Intl.PluralRules('en'),
  fil: new Intl.PluralRules('fil'),
}

/**
 * The text for `key` in `lang`, with `{name}` replaced from `values`. A plural entry picks its
 * form from `values.n`. An empty Filipino text falls back to English, never to the key.
 */
export function translate(lang: Lang, key: MessageKey, values?: Record<string, string | number>): string {
  const entry = catalogue[key]
  const pick = (t: Text): string => {
    if (typeof t === 'string') return t
    const n = Number(values?.n ?? 0)
    return plurals[lang].select(n) === 'one' ? t.one : t.other
  }
  let text = pick(entry[lang])
  if (!text) text = pick(entry.en)
  return text.replace(/\{(\w+)\}/g, (m, name: string) => (values && name in values ? String(values[name]) : m))
}
